export default class Colores 
{
    constructor()
    {
        this.paleta = {
            color1: '#222431',
            color2: '#F9E2D0',
            color3: '#C1403A',
            color4: '#458376',
            color5: '#313c90',
            color6: '#cfd0d9'
            
        },
        this.luces = {
            ambient: '#FFFFFF',
            point: '#FFFFFF',
            directional: '#FFFFFF'//#fff7e0
        },
        this.mascaras = {
            mascara1: '#9eb15f',//Disponible
            mascara2: '#e25252',//Vendido
            mascara3: '#e2a552',//Opcionado
            mascara4: '#458376',
            mascara5: '#313c90',
            mascaraHover: '#ffffff',//'#ce9943'
            mascaraClick: '#ffffff',
            mascaraLinea: '#ffffff',
            mascaraZonas: '#e25252'
        }
        this.coloresMundo = {
            blanco: '#FFFFFF',
            colorAmbiente: '#FFFFFF',
            colorProyecto: '#A0AAB4',
            colorProyectoAlt: this.paleta.color3,
            colorVecinos: '#dbe1e6',//c7cbd1
            colorEdificios: '#c5bcaf',//#dbe1e6
            colorEdificiosLinea: '#ffffff',
            colorVias: '#82cde2',
            colorTransito: '#222431',
            colorAlerta: '#C1403A',
            colorArboles: '#afb992',
            colorAndenes: '#DCE1E5',
            colorCielo: '#FFFFFF',//f8f2ea 
            colorBruma: '#cbf0ff',//f8f5f0
            colorTerreno: '#545f35',
            colorNubes: '#dbdbdb',
            //Colores version alterna
            colorBarandas: '#ffffff',
            colorBbq: '#84889f',
            colorCarros: '#dfd8c8',
            colorComunal: '#ffffff',//#f3f1e8
            colorJuegos: '#84889f',
            colorLuminarias: '#222431',
            colorTorres: '#ffffff',//#f3f1e8
            colorTorresLineas: '#ffffff',
            colorUrbano: '#ffffff',
            colorPersonas: '#ffffff'
        }
    }
}
